<cst-card>
  <ng-template cstCardContent>
    @if (form) {
      <div class="card-wrapper">
        @for (item of stammData; track item; let i = $index) {
          <div>
            <ng-template
              *ngTemplateOutlet="stammItem; context: { item: item, index: i }"
            ></ng-template>
          </div>
        }
      </div>
    }
  </ng-template>
</cst-card>

<ng-template #stammItem let-item="item" let-index="index">

        <tab-formular-input-control
          [inputFormGroup]="form"
          [inputFormGroupName]="formularGroupDataKey"
          [inputControl]="controls[index]"
          [inputLabel]="item['Label']"
          [htmlType]="inputTypeToHtmlType(getInputString(item['ManualInputType']))"
          [isReadOnly]="item['IsReadonly']"
        >
        </tab-formular-input-control>
<!-- 
  <form [formGroup]="form" [ngClass]="{ disabled: item['IsReadonly'] }">
    <div
      formGroupName="{{ formularGroupDataKey }}"
      [class.eyecatching]="item['IsEyeCatching']"
    >
      @switch (inputTypeToHtmlType(getInputString(item["ManualInputType"]))) {
        @case ("checkbox") {
          <ng-container
            *ngTemplateOutlet="
              chkBoxInput;
              context: { inpt: inpt, index: index }
            "
          ></ng-container>
        }
        @case ("text") {
          <ng-container
            *ngTemplateOutlet="textInput; context: { inpt: inpt, index: index }"
          ></ng-container>
        }
        @case ("textarea") {
          <ng-container
            *ngTemplateOutlet="
              textAreaInput;
              context: { inpt: inpt, index: index }
            "
          ></ng-container>
        }
        @case ("date") {
          <ng-container
            *ngTemplateOutlet="
              datePicker;
              context: { inpt: inpt, index: index }
            "
          ></ng-container>
        }
        @case ("time") {
          <ng-container
            *ngTemplateOutlet="
              timePicker;
              context: { inpt: inpt, index: index }
            "
          >
          </ng-container>
        }
        @case ("datetime-local") {
          <ng-container
            *ngTemplateOutlet="
              dateTimePicker;
              context: { inpt: inpt, index: index }
            "
          ></ng-container>
        }
        @default {
          {{ index }}: {{ stringify(inpt) }}<br />
          UNKNOWN INPUT TYPE:
          {{ inpt["Type"] }} (Parsed as:
          {{ inputTypeToHtmlType(inpt["Type"]) }})
        }
      }
    </div>
  </form> -->
</ng-template>
